import React from 'react';
import { useMutation } from '@apollo/client';
import ConfirmConnectionMutation from './ConfirmConnectionMutation';
import WearableConnectionsQuery from '../Fetch/WearableConnectionsQuery';
import type { WearableMutationResult } from '../DisconnectWearable/DisconnectWearableConnectorApollo';

interface Result {
  confirmConnection: (providerKey: string) => Promise<WearableMutationResult>;
  loading: boolean;
}

interface Props {
  children: (result: Result) => React.ReactElement;
}

const ConfirmConnectionConnectorApollo: React.FC<Props> = ({ children }) => {
  const [mutate, { loading }] = useMutation(ConfirmConnectionMutation, {
    refetchQueries: [{ query: WearableConnectionsQuery }],
    awaitRefetchQueries: true,
  });

  const confirmConnection = async (providerKey: string): Promise<WearableMutationResult> => {
    try {
      const response = await mutate({ variables: { provider: providerKey } });
      const payload = response.data?.wearable?.confirmConnection;

      if (payload?.__typename === 'BasicMutationSuccess') {
        return { ok: true };
      }

      const message =
        payload?.description || payload?.name || payload?.code || 'wearable_confirm_error';
      return { ok: false, reason: 'server', message };
    } catch (error) {
      const message = error instanceof Error ? error.message : 'wearable_confirm_network_error';
      return { ok: false, reason: 'network', message };
    }
  };

  return children({ confirmConnection, loading });
};

export default ConfirmConnectionConnectorApollo;
